import FaqDropdown from "@/components/ui/faq-drodpdown";
import Section from "@/components/ui/section";
import React from "react";
import { faqData } from "@/components/data/faq-data";
export default function Faq() {
  return (
    <Section>
      <div className="mx-auto  w-full">
        {/* <p className="lg:text-[20px] text-base text-black/90 font-medium text-left mb-5">
          Frequently Asked Questions
        </p> */}
        {faqData?.map((row, key) => (
          <FaqDropdown key={"faq" + key} title={row?.question} initial={false}>
            {row?.answer}
          </FaqDropdown>
        ))}
      </div>
    </Section>
  );
}
